import React from 'react';
import './Shapes.scss';
import './CustomImage.css'
import { fabric } from 'fabric';
import { Accordion } from './Accordion';

import __ from './../utils/translation';

import { ReactComponent as Shape01 } from './../shapes/01-rectangle.svg';
import { ReactComponent as Shape02 } from './../shapes/02-diamond.svg';
import { ReactComponent as Shape03 } from './../shapes/03-rectangle-dist.svg';
import { ReactComponent as Shape04 } from './../shapes/04-trapeze.svg';
import { ReactComponent as Shape05 } from './../shapes/05-frame.svg';

import { ReactComponent as Shape06 } from './../shapes/06-5-angle.svg';
import { ReactComponent as Shape07 } from './../shapes/07-6-angle.svg';
import { ReactComponent as Shape08 } from './../shapes/08-8-angle.svg';
import { ReactComponent as Shape09 } from './../shapes/09-5-angle-half.svg';
import { ReactComponent as Shape10 } from './../shapes/10-6-angle-half.svg';

import { ReactComponent as Shape11 } from './../shapes/11-triangle-even.svg';
import { ReactComponent as Shape12 } from './../shapes/12-triangle-odd.svg';
import { ReactComponent as Shape13 } from './../shapes/13-triangle-frame-even.svg';
import { ReactComponent as Shape14 } from './../shapes/14-triangle-frame-odd.svg';
import { ReactComponent as Shape15 } from './../shapes/15-circle.svg';

import { ReactComponent as Shape16 } from './../shapes/16-half-circle.svg';
import { ReactComponent as Shape17 } from './../shapes/17-half-pushed-circle.svg';
import { ReactComponent as Shape18 } from './../shapes/18-pushed-circle.svg';
import { ReactComponent as Shape19 } from './../shapes/19-circle-frame.svg';
import { ReactComponent as Shape20 } from './../shapes/20-half-circle-frame.svg';

import { ReactComponent as Shape21 } from './../shapes/21-star-4.svg';
import { ReactComponent as Shape22 } from './../shapes/22-star-5.svg';
import { ReactComponent as Shape23 } from './../shapes/23-star-12.svg';
import { ReactComponent as Shape24 } from './../shapes/24-star-24a.svg';
import { ReactComponent as Shape25 } from './../shapes/25-star-24b.svg';

import { ReactComponent as Shape26 } from './../shapes/26-arrow.svg';
import { ReactComponent as Shape27 } from './../shapes/27-arrow-2-way.svg';
import { ReactComponent as Shape28 } from './../shapes/28-arrow-2-way-turn.svg';
import { ReactComponent as Shape29 } from './../shapes/29-arrow-3-way.svg';
import { ReactComponent as Shape30 } from './../shapes/30-arrow-4-way.svg';

import { ReactComponent as Shape31 } from './../shapes/31-arrow-turn.svg';
import { ReactComponent as Shape32 } from './../shapes/32-arrow-turn-full.svg';
import { ReactComponent as Shape33 } from './../shapes/33-chat-rect.svg';
import { ReactComponent as Shape34 } from './../shapes/34-chat-circle.svg';
import { ReactComponent as Shape35 } from './../shapes/35-chat-thought.svg';
import  Shape36  from './../shapes/Artboard 1.png';
import  Shape37  from './../shapes/Artboard 1 copy.png';
import  Shape38  from './../shapes/Artboard 1 copy 2.png';
import  Shape39  from './../shapes/Artboard 1 copy 3.png';
import  Shape40  from './../shapes/Artboard 1 copy 4.png';
import  Shape41  from './../shapes/Artboard 1 copy 5.png';
import  Shape42  from './../shapes/Artboard 1 copy 7.png';
import  Shape43  from './../shapes/Artboard 1 copy 8.png';
import  Shape44  from './../shapes/Artboard 1 copy 9.png';
import  Shape45  from './../shapes/Artboard 1 copy 10.png';
import  Shape46  from './../shapes/Artboard 1 copy 11.png';
import  Shape47  from './../shapes/Artboard 1 copy 12.png';
import  Shape48  from './../shapes/Artboard 1 copy 13.png';
import  Shape49  from './../shapes/Artboard 1 copy 14.png';
import  Shape50  from './../shapes/Artboard 1 copy 15.png';
import  Shape51  from './../shapes/Artboard 1 copy 16.png';
import  Shape52  from './../shapes/Artboard 1 copy 18.png';
import  Shape53  from './../shapes/Artboard 1 copy 19.png';
import  Shape54  from './../shapes/Artboard 1 copy 20.png';
import  Shape55  from './../shapes/Artboard 1 copy 21.png';
import  Shape56  from './../shapes/Artboard 1 copy 22.png';
import  Shape57  from './../shapes/Artboard 1 copy 23.png';
import  Shape58  from './../shapes/Artboard 1 copy 24.png';
import  Shape59  from './../shapes/Artboard 1 copy 25.png';
import  Shape60  from './../shapes/Artboard 1 copy 26.png';
import  Shape61  from './../shapes/Artboard 1 copy 27.png';
import  Shape62  from './../shapes/Artboard 1 copy 28.png';
import  Shape63  from './../shapes/Artboard 1 copy 29.png';
import  Shape64  from './../shapes/Artboard 1 copy 30.png';
import  Shape65  from './../shapes/Artboard 1 copy 31.png';
import  Shape66  from './../shapes/Artboard 1 copy 32.png';
import  Shape67  from './../shapes/Artboard 1 copy 33.png';
import  Shape68  from './../shapes/Artboard 1 copy 34.png';
import  Shape69  from './../shapes/Artboard 1 copy 35.png';
import  Shape70  from './../shapes/Artboard 1 copy 36.png';
import  Shape71  from './../shapes/Artboard 1 copy 37.png';
import  Shape72  from './../shapes/Artboard 1 copy 38.png';
import  Shape73 from './../shapes/Artboard 1 copy 39.png';
import  Shape74  from './../shapes/Artboard 1 copy 6.png';
import  Shape75  from './../shapes/Artboard 1 copy 17.png';
//Kidney Shapes
import  Shape76  from './../shapes/sjinox-imges/Artboard 1 copy 40300.png';
import  Shape77  from './../shapes/sjinox-imges/Artboard 1 copy 56300.png';
import  Shape78  from './../shapes/sjinox-imges/Artboard 1 copy 48300.png';
import  Shape79  from './../shapes/sjinox-imges/Artboard 1 copy 64300.png';
import  Shape80  from './../shapes/sjinox-imges/Artboard 1 copy 72300.png';
import  Shape81  from './../shapes/sjinox-imges/Artboard 1 copy 80300.png';
import  KidneyOutline from './../shapes/outlineShapes/KidneyOutline.png';

//Rounded Rectangle Shapes
import  Shape82  from './../shapes/sjinox-imges/Artboard 1 copy 41300.png';
import  Shape83  from './../shapes/sjinox-imges/Artboard 1 copy 57300.png';
import  Shape84  from './../shapes/sjinox-imges/Artboard 1 copy 49300.png';
import  Shape85  from './../shapes/sjinox-imges/Artboard 1 copy 65300.png';
import  Shape86  from './../shapes/sjinox-imges/Artboard 1 copy 73300.png';
import  Shape87  from './../shapes/sjinox-imges/Artboard 1 copy 81300.png';
import  FullRectOutline from './../shapes/outlineShapes/RectangularOutline.png';

//Oval Shapes
import  Shape88  from './../shapes/sjinox-imges/Artboard 1 copy 42300.png';
import  Shape89  from './../shapes/sjinox-imges/Artboard 1 copy 58300.png';
import  Shape90  from './../shapes/sjinox-imges/Artboard 1 copy 50300.png';
import  Shape91  from './../shapes/sjinox-imges/Artboard 1 copy 66300.png';
import  Shape92  from './../shapes/sjinox-imges/Artboard 1 copy 74300.png';
import  Shape93  from './../shapes/sjinox-imges/Artboard 1 copy 82300.png';
import  OvalOutline from './../shapes/outlineShapes/Oval.png';

//180D shapes
import  Shape94  from './../shapes/sjinox-imges/Artboard 1 copy 43300.png';
import  Shape95  from './../shapes/sjinox-imges/Artboard 1 copy 59300.png';
import  Shape96  from './../shapes/sjinox-imges/Artboard 1 copy 51300.png';
import  Shape97  from './../shapes/sjinox-imges/Artboard 1 copy 67300.png';
import  Shape98  from './../shapes/sjinox-imges/Artboard 1 copy 75300.png';
import  Shape99  from './../shapes/sjinox-imges/Artboard 1 copy 83300.png';
import  Doutline from './../shapes/outlineShapes/180DOuline.png';

//Square Shapes
import  Shape100  from './../shapes/sjinox-imges/Artboard 1 copy 44300.png';
import  Shape101  from './../shapes/sjinox-imges/Artboard 1 copy 60300.png';
import  Shape102  from './../shapes/sjinox-imges/Artboard 1 copy 52300.png';
import  Shape103  from './../shapes/sjinox-imges/Artboard 1 copy 68300.png';
import  Shape104  from './../shapes/sjinox-imges/Artboard 1 copy 76300.png';
import  Shape105  from './../shapes/sjinox-imges/Artboard 1 copy 84300.png';
import  SquareOutlne  from './../shapes/outlineShapes/Square-Outline.png';

//Half D shapes
import  Shape106  from './../shapes/sjinox-imges/Artboard 1 copy 45300.png';
import  Shape107  from './../shapes/sjinox-imges/Artboard 1 copy 61300.png';
import  Shape108  from './../shapes/sjinox-imges/Artboard 1 copy 53300.png';
import  Shape109  from './../shapes/sjinox-imges/Artboard 1 copy 69300.png';
import  Shape110  from './../shapes/sjinox-imges/Artboard 1 copy 77300.png';
import  Shape111  from './../shapes/sjinox-imges/Artboard 1 copy 85300.png';
//Vas Shapes
import  Shape112  from './../shapes/sjinox-imges/Artboard 1 copy 46300.png';
import  Shape113  from './../shapes/sjinox-imges/Artboard 1 copy 62300.png';
import  Shape114  from './../shapes/sjinox-imges/Artboard 1 copy 54300.png';
import  Shape115  from './../shapes/sjinox-imges/Artboard 1 copy 70300.png';
import  Shape116  from './../shapes/sjinox-imges/Artboard 1 copy 78300.png';
import  Shape117  from './../shapes/sjinox-imges/Artboard 1 copy 86300.png';
import  VasOutline from './../shapes/outlineShapes/VasOutline.png';

//Circle Shapes
import  Shape118  from './../shapes/sjinox-imges/Artboard 1 copy 47300.png';
import  Shape119  from './../shapes/sjinox-imges/Artboard 1 copy 63300.png';
import  Shape120  from './../shapes/sjinox-imges/Artboard 1 copy 55300.png';
import  Shape121  from './../shapes/sjinox-imges/Artboard 1 copy 71300.png';
import  Shape122  from './../shapes/sjinox-imges/Artboard 1 copy 79300.png';
import  Shape123  from './../shapes/sjinox-imges/Artboard 1 copy 87300.png';
import  CircleOutline from './../shapes/outlineShapes/Circle-outline.png';

// Parent shapes
import  kidney  from './../shapes/Kidney-shape.svg';
import  Circle  from './../shapes/cirlce-360.svg';
import  halfRectanguler  from './../shapes/half-rectanguler.svg';
import  Oval  from './../shapes/Oval.svg';
import  RoundedRectanguler  from './../shapes/Rounded_Rectanglr.svg';
import  Square  from './../shapes/square.svg';
import  Vas  from './../shapes/Vas.svg';
import  D180  from './../shapes/180-D-circle.svg';
import  Others  from './../shapes/others.svg';
import  HalfRectangOutline from './../shapes/outlineShapes/HalfRectangOutline.png';

// 2 NOV PIC

import Shape124 from '../shapes/2-Nov-Imgs/Artboard 1 copy 72.png'
import Shape125 from '../shapes/2-Nov-Imgs/Artboard 1 copy 73.png'
import Shape126 from '../shapes/2-Nov-Imgs/Artboard 1 copy 74.png'
import Shape127 from '../shapes/2-Nov-Imgs/Artboard 1 copy 75.png'
import Shape128 from '../shapes/2-Nov-Imgs/Artboard 1 copy 76.png'
import Shape129 from '../shapes/2-Nov-Imgs/Artboard 1 copy 77.png'
import Shape130 from '../shapes/2-Nov-Imgs/Artboard 1 copy 78.png'
import Shape131 from '../shapes/2-Nov-Imgs/Artboard 1 copy 79.png'
import Shape132 from '../shapes/2-Nov-Imgs/Artboard 1 copy 80.png'
import Shape133 from '../shapes/2-Nov-Imgs/Artboard 1 copy 81.png'
import Shape134 from '../shapes/2-Nov-Imgs/Artboard 1 copy 82.png'
import Shape135 from '../shapes/2-Nov-Imgs/Artboard 1 copy 83.png'
import Shape136 from '../shapes/2-Nov-Imgs/Artboard 1 copy 84.png'
import Shape137 from '../shapes/2-Nov-Imgs/Artboard 1 copy 85.png'
import Shape138 from '../shapes/2-Nov-Imgs/Artboard 1 copy 86.png'
import Shape139 from '../shapes/2-Nov-Imgs/Artboard 1 copy 87.png'
import Shape140 from '../shapes/2-Nov-Imgs/Artboard 1 copy 88.png'
import Shape141 from '../shapes/2-Nov-Imgs/Artboard 1 copy 89.png'
import Shape142 from '../shapes/2-Nov-Imgs/Artboard 1 copy 90.png'
import Shape143 from '../shapes/2-Nov-Imgs/Artboard 1 copy 90.png'
import Shape144 from '../shapes/2-Nov-Imgs/Artboard 1 copy 91.png'
import Shape145 from '../shapes/2-Nov-Imgs/Artboard 1 copy 92.png'
import Shape146 from '../shapes/2-Nov-Imgs/Artboard 1 copy 93.png'
import Shape147 from '../shapes/2-Nov-Imgs/Artboard 1 copy 94.png'
import Shape148 from '../shapes/2-Nov-Imgs/Artboard 1 copy 95.png'
import Shape149 from '../shapes/2-Nov-Imgs/Artboard 1 copy 96.png'
import Shape150 from '../shapes/2-Nov-Imgs/Artboard 1 copy 97.png'
import Shape151 from '../shapes/2-Nov-Imgs/Artboard 1 copy 98.png'
import Shape152 from '../shapes/2-Nov-Imgs/Artboard 1 copy 99.png'
import Shape153 from '../shapes/2-Nov-Imgs/Artboard 1 copy 100.png'
import Shape154 from '../shapes/2-Nov-Imgs/Artboard 1 copy 101.png'
import Shape155 from '../shapes/2-Nov-Imgs/Artboard 1 copy 102.png'
import Shape156 from '../shapes/2-Nov-Imgs/Artboard 1 copy 103.png'
import Shape157 from '../shapes/2-Nov-Imgs/Artboard 1 copy 104.png'
import Shape158 from '../shapes/2-Nov-Imgs/Artboard 1 copy 105.png'
import Shape159 from '../shapes/2-Nov-Imgs/Artboard 1 copy 106.png'
import Shape160 from '../shapes/2-Nov-Imgs/Artboard 1 copy 107.png'
import Shape161 from '../shapes/2-Nov-Imgs/Artboard 1 copy 108.png'
import Shape162 from '../shapes/2-Nov-Imgs/Artboard 1 copy 109.png'
import Shape163 from '../shapes/2-Nov-Imgs/Artboard 1 copy 110.png'
import Shape164 from '../shapes/2-Nov-Imgs/Artboard 1 copy 111.png'
import Shape165 from '../shapes/2-Nov-Imgs/Artboard 1 copy 112.png'
import Shape166 from '../shapes/2-Nov-Imgs/Artboard 1 copy 113.png'
import Shape167 from '../shapes/2-Nov-Imgs/Artboard 1 copy 114.png'
import Shape168 from '../shapes/2-Nov-Imgs/Artboard 1 copy 115.png'
import Shape169 from '../shapes/2-Nov-Imgs/Artboard 1 copy 116.png'
import Shape170 from '../shapes/2-Nov-Imgs/Artboard 1 copy 117.png'
import Shape171 from '../shapes/2-Nov-Imgs/Artboard 1 copy 118.png'
import Shape172 from '../shapes/2-Nov-Imgs/Artboard 1 copy 119.png'
import Shape173 from '../shapes/2-Nov-Imgs/Artboard 1 copy 120.png'
import Shape174 from '../shapes/2-Nov-Imgs/Artboard 1 copy 121.png'
import Shape175 from '../shapes/2-Nov-Imgs/Artboard 1 copy 122.png'
import Shape176 from '../shapes/2-Nov-Imgs/Artboard 1 copy 123.png'
import Shape177 from '../shapes/2-Nov-Imgs/Artboard 1 copy 124.png'
import Shape178 from '../shapes/2-Nov-Imgs/Artboard 1 copy 125.png'
import Shape179 from '../shapes/2-Nov-Imgs/Artboard 1 copy 126.png'
import Shape180 from '../shapes/2-Nov-Imgs/Artboard 1 copy 127.png'
import Shape181 from '../shapes/2-Nov-Imgs/Artboard 1 copy 128.png'
import Shape182 from '../shapes/2-Nov-Imgs/Artboard 1 copy 129.png'
import Shape183 from '../shapes/2-Nov-Imgs/Artboard 1 copy 130.png'
import Shape184 from '../shapes/2-Nov-Imgs/Artboard 1 copy 131.png'
import Shape185 from '../shapes/2-Nov-Imgs/Artboard 1 copy 132.png'
import Shape186 from '../shapes/2-Nov-Imgs/Artboard 1 copy 133.png'
import Shape187 from '../shapes/2-Nov-Imgs/Artboard 1 copy 134.png'
import Shape188 from '../shapes/2-Nov-Imgs/Artboard 1 copy 135.png'
import Shape189 from '../shapes/2-Nov-Imgs/Artboard 1 copy 136.png'
import Shape190 from '../shapes/2-Nov-Imgs/Artboard 1 copy 137.png'
import Shape191 from '../shapes/2-Nov-Imgs/Artboard 1 copy 138.png'
import Shape192 from '../shapes/2-Nov-Imgs/Artboard 1 copy 139.png'
import Shape193 from '../shapes/2-Nov-Imgs/Artboard 1 copy 140.png'
import Shape194 from '../shapes/2-Nov-Imgs/Artboard 1 copy 141.png'
import Shape195 from '../shapes/2-Nov-Imgs/Artboard 1 copy 142.png'
import Shape196 from '../shapes/2-Nov-Imgs/Artboard 1 copy 143.png'
import Shape197 from '../shapes/2-Nov-Imgs/Artboard 1 copy 144.png'
import Shape198 from '../shapes/2-Nov-Imgs/Artboard 1 copy 145.png'
import Shape199 from '../shapes/2-Nov-Imgs/Artboard 1 copy 146.png'
import Shape200 from '../shapes/2-Nov-Imgs/Artboard 1 copy 147.png'
import Shape201 from '../shapes/2-Nov-Imgs/Artboard 1 copy 148.png'
import Shape202 from '../shapes/2-Nov-Imgs/Artboard 1 copy 149.png'
import Shape203 from '../shapes/2-Nov-Imgs/Artboard 1 copy 150.png'
import Shape204 from '../shapes/2-Nov-Imgs/Artboard 1 copy 151.png'
import Shape205 from '../shapes/2-Nov-Imgs/Artboard 1 copy 152.png'
import Shape206 from '../shapes/2-Nov-Imgs/Artboard 1 copy 153.png'
import Shape207 from '../shapes/2-Nov-Imgs/Artboard 1 copy 154.png'
import Shape208 from '../shapes/2-Nov-Imgs/Artboard 1 copy 155.png'
import Shape209 from '../shapes/2-Nov-Imgs/Artboard 1 copy 156.png'
import Shape210 from '../shapes/2-Nov-Imgs/Artboard 1 copy 157.png'
import Shape211 from '../shapes/2-Nov-Imgs/Artboard 1 copy 158.png'
import Shape212 from '../shapes/2-Nov-Imgs/Artboard 1 copy 159.png'
import Shape213 from '../shapes/2-Nov-Imgs/Artboard 1 copy 160.png'
import Shape214 from '../shapes/2-Nov-Imgs/Artboard 1 copy 161.png'
import Shape215 from '../shapes/2-Nov-Imgs/Artboard 1 copy 162.png'
import Shape216 from '../shapes/2-Nov-Imgs/Artboard 1 copy 163.png'
import Shape217 from '../shapes/2-Nov-Imgs/Artboard 1 copy 164.png'
import Shape218 from '../shapes/2-Nov-Imgs/Artboard 1 copy 165.png'
import Shape219 from '../shapes/2-Nov-Imgs/Artboard 1 copy 166.png'
import Shape220 from '../shapes/2-Nov-Imgs/Artboard 1 copy 167.png'
import Shape221 from '../shapes/2-Nov-Imgs/Artboard 1 copy 168.png'
import Shape222 from '../shapes/2-Nov-Imgs/Artboard 1 copy 169.png'
import Shape223 from '../shapes/2-Nov-Imgs/Artboard 1 copy 170.png'
import Shape224 from '../shapes/2-Nov-Imgs/Artboard 1 copy 171.png'
import Shape225 from '../shapes/2-Nov-Imgs/Artboard 1 copy 172.png'
import Shape226 from '../shapes/2-Nov-Imgs/Artboard 1 copy 173.png'
import Shape227 from '../shapes/2-Nov-Imgs/Artboard 1 copy 174.png'
import Shape228 from '../shapes/2-Nov-Imgs/Artboard 1 copy 175.png'
import Shape229 from '../shapes/2-Nov-Imgs/Artboard 1 copy 176.png'
import Shape230 from '../shapes/2-Nov-Imgs/Artboard 1 copy 177.png'
import Shape231 from '../shapes/2-Nov-Imgs/Artboard 1 copy 178.png'
import Shape232 from '../shapes/2-Nov-Imgs/Artboard 1 copy 179.png'
import Shape233 from '../shapes/2-Nov-Imgs/Artboard 1 copy 180.png'
import Shape234 from '../shapes/2-Nov-Imgs/Artboard 1 copy 181.png'
import Shape235 from '../shapes/2-Nov-Imgs/Artboard 1 copy 182.png'
import Shape236 from '../shapes/2-Nov-Imgs/Artboard 1 copy 183.png'


const Shapes = ({ canvas }) => {

  const handleShapeAdd = (e) => {
    fabric.loadSVGFromString(
      e.currentTarget.children[0].outerHTML,
      (objects, options) => {
        var obj = fabric.util.groupSVGElements(objects, options)
        obj.strokeUniform = true
        obj.strokeLineJoin = 'miter'
        obj.scaleToWidth(100)
        obj.scaleToHeight(100)
        obj.set({ left: (canvas.getWidth()/2), top: (canvas.getHeight()/4) })
        canvas.add(obj).renderAll()
        canvas.trigger('object:modified')
      }
    )
  }
  const handleImgAdd = (e) => {
    const imageLink = e.target.src;
    let src = imageLink;
    fabric.Image.fromURL(src, (img) => {
      img.set({left: 50, top: 50})
      img.scaleToHeight(100)
      img.scaleToWidth(200)
      canvas.add(img)
      canvas.renderAll()
      canvas.trigger('object:modified')
    })
  }

  return (
    <>
      <p className="title">{__('SHAPES')}</p>

      {/* <div className="shapes">
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape01 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape02 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape03 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape04 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape05 /></div>

        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape06 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape07 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape08 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape09 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape10 /></div>

        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape11 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape12 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape13 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape14 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape15 /></div>

        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape16 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape17 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape18 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape19 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape20 /></div>

        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape21 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape22 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape23 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape24 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape25 /></div>

        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape26 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape27 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape28 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape29 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape30 /></div>

        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape31 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape32 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape33 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape34 /></div>
        <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape35 /></div>

      </div> */}
      <div className="my-new-settings">
        <div className="Img__default">
          <div className="wrapper">
            <Accordion title={'Circle Shapes'}  image={Circle}>
              <section id='photos'>
                <img onClick={handleImgAdd} src={Shape74} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape50} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape57} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape65} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape73} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape118} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape119} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape120} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape121} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape122} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape123} alt='Testing'/>
                <img onClick={handleImgAdd} src={CircleOutline} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape131} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape205} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape206} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape207} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape208} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape209} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape210} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape211} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape212} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape213} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape214} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape215} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape216} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape230} alt='Testing'/>
              </section>
            </Accordion >
            <Accordion title={'Square Shapes'} image={Square}>
              <section id='photos'>
                <img onClick={handleImgAdd} src={Shape42} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape47} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape54} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape62} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape70} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape100} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape101} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape102} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape103} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape104} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape105} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape128} alt='Testing'/>
                <img onClick={handleImgAdd} src={SquareOutlne} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape193} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape194} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape195} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape196} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape197} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape198} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape199} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape200} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape201} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape202} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape203} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape204} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape231} alt='Testing'/>
              </section>
            </Accordion >
            <Accordion title={'D180 Shapes'} image={D180}>
              <section id='photos'>
                <img onClick={handleImgAdd} src={Shape39} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape46} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape53} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape61} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape69} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape94} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape95} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape96} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape97} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape98} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape99} alt='Testing'/>
                <img onClick={handleImgAdd} src={Doutline} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape127} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape169} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape170} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape171} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape172} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape173} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape174} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape175} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape176} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape177} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape178} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape179} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape180} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape233} alt='Testing'/>

              </section>
            </Accordion >
            <Accordion title={'Kidney Shapes'}  image={kidney}>
              <section id='photos'>
                <img onClick={handleImgAdd} src={Shape43} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape51} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape58} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape66} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape36} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape76} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape77} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape78} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape79} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape80} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape81} alt='Testing'/>
                <img onClick={handleImgAdd} src={KidneyOutline} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape124} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape132} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape133} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape134} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape135} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape136} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape137} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape138} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape139} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape140} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape141} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape142} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape143} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape144} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape236} alt='Testing'/>
              </section>
            </Accordion >
            <Accordion title={'Oval Shapes'} image={Oval}>
              <section id='photos'>
                <img onClick={handleImgAdd} src={Shape38} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape45} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape52} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape60} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape68} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape88} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape89} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape90} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape91} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape92} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape93} alt='Testing'/>
                <img onClick={handleImgAdd} src={OvalOutline} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape126} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape157} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape158} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape159} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape160} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape161} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape162} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape163} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape164} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape165} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape166} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape167} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape168} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape234} alt='Testing'/>
              </section>
            </Accordion >
            <Accordion title={'Rectangular Shapes'} image={RoundedRectanguler}>
              <section id='photos'>
                <img onClick={handleImgAdd} src={Shape44} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape75} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape59} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape67} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape37} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape82} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape83} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape84} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape85} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape86} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape87} alt='Testing'/>
                <img onClick={handleImgAdd} src={FullRectOutline} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape125} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape145} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape146} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape147} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape148} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape149} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape150} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape151} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape152} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape153} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape154} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape155} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape156} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape235} alt='Testing'/>


              </section>
            </Accordion >
            <Accordion  title={'Half Rectanguler Shapes'} image={halfRectanguler}>
              <section id='photos'>
                <img onClick={handleImgAdd} src={Shape40} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape48} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape55} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape63} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape71} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape106} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape107} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape108} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape109} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape110} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape111} alt='Testing'/>
                <img onClick={handleImgAdd} src={HalfRectangOutline} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape129} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape181} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape182} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape183} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape184} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape185} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape186} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape187} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape188} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape189} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape190} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape191} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape192} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape232} alt='Testing'/>
              </section>
            </Accordion >
            <Accordion  title={'Vas Shapes'} image={Vas}>
              <section id='photos'>
                <img onClick={handleImgAdd} src={Shape41} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape49} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape56} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape64} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape72} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape112} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape113} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape114} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape115} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape116} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape117} alt='Testing'/>
                <img onClick={handleImgAdd} src={VasOutline} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape130} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape217} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape218} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape219} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape220} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape221} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape222} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape223} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape224} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape225} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape226} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape227} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape228} alt='Testing'/>
                <img onClick={handleImgAdd} src={Shape229} alt='Testing'/>
              </section>
            </Accordion >
            <Accordion  title={'Other Shapes'} image={Others}>
            <div className="shapes">
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape01 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape02 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape03 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape04 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape05 /></div>

                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape06 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape07 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape08 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape09 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape10 /></div>

                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape11 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape12 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape13 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape14 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape15 /></div>

                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape16 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape17 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape18 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape19 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape20 /></div>

                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape21 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape22 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape23 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape24 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape25 /></div>

                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape26 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape27 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape28 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape29 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape30 /></div>

                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape31 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape32 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape33 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape34 /></div>
                <div className="button" onClick={(e) => handleShapeAdd(e)}><Shape35 /></div>

              </div>
            </Accordion >
          </div>
          </div>
        </div>
    </>
  )

}

export default Shapes

